import { useQuery } from 'react-query';
import { NarrativeRequest } from 'utilitys/narrative/narrativeTools';

import { getProgressScurveGraph as queryFn } from 'api/endPoints/getProgressScurveGraph';
import { QueryKeys } from 'api/queryKeys';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export const useQueryGetCriticalityWeightScurveGraph = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, (QueryKeys | QueryParams)[]>({
        queryKey: ['getProgressScurveGraph', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.actualMetaDataId && params.baselineMetaDataId && params.graphType),
    });
};

interface Data {
    text: string;
    label: number;
    value: number;
}

interface GraphLine {
    title: string | null;
    seriesname: null;
    data: Data[];
}

export interface QueryResponse {
    nowDate: string;
    plannedGraphLine: GraphLine;
    actualGraphLine: GraphLine;
    forecatsGraphLine: GraphLine;
    info: IToolTip;
}

export interface QueryParams extends NarrativeRequest {
    actualMetaDataId: number | undefined;
    baselineMetaDataId: number | undefined;
    graphType: string;
    isPartialCompletion: string;
    filter: {
        filters: IFilter[] | undefined;
    };
}
